// DynamicTable.tsx
import React, { useState } from 'react';
import './DynamicTable.css';
import { TableColumn } from '../../interface/interface';
import { defaultValueForSelect } from '../../utils/Config';
import { ListTypeEntry } from '../../context/ListTypeEntriesProvider';
import Button from '@clayui/button';
import { primaryButtonStyle } from '../../utils/commonUtil';
import CustomMultiSelectInline from '../MultiSelect/CustomMultiSelectInline';

interface Props {
    columns: TableColumn[];
    initialData?: any[];
    readOnly?: boolean;
    // options?: ListTypeEntry[] | null;
    options?: any;
    onChange?: (data: any[]) => void;
    disableAdd?: boolean;
    errors?: string[];
    marketPriority?: ListTypeEntry[] | null;
    businessPurpose?: any;
}

const DynamicTable: React.FC<Props> = ({
    columns,
    initialData = [{}],
    readOnly = false,
    options,
    onChange,
    disableAdd = false,
    errors = [],
    marketPriority,
    businessPurpose
}) => {
    // ... (handleChange)
    const handleChange = (
        rowIndex: number,
        field: string,
        value: string | string[]
    ) => {
        if (!onChange) return;

        const updatedData = [...initialData];
        updatedData[rowIndex] = {
            ...updatedData[rowIndex],
            [field]: value
        };

        onChange(updatedData);
    };

    const handleAddRow = () => {
        if (!onChange || disableAdd) return; // Prevent add if disabled

        onChange([
            ...initialData,
            {
                targetMarket: '',
                purposeOfExpansion: [],
                previousExperience: '',
                marketPriority: ''
            }
        ]);
    };

    const handleDeleteRow = (index: number) => {
        if (!onChange) return;

        onChange(initialData.filter((_, i) => i !== index));
    };

    return (
        <>
            <div className="dynamic-table-wrapper">
                <table className="dynamic-table">
                    <thead>
                        <tr>
                            {columns.map((col) => (
                                <th
                                    key={col.key}
                                    // style={{ width: col.width }}
                                    style={{
                                        width: col.width,
                                        minWidth:
                                            col.key === 'purposeOfExpansion'
                                                ? '400px'
                                                : ''
                                    }}
                                >
                                    {col.header}
                                </th>
                            ))}
                            {!readOnly && (
                                <th style={{ width: '6%' }}>Action</th>
                            )}
                        </tr>
                    </thead>

                    <tbody>
                        {initialData?.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {columns.map((col) => (
                                    <td
                                        key={col.key}
                                        className={readOnly ? 'py-2' : 'py-1'}
                                    >
                                        {readOnly ? (
                                            Array.isArray(row[col.key]) ? (
                                                row[col.key].join(', ')
                                            ) : (
                                                row[col.key] || '-'
                                            )
                                        ) : col.key === 'purposeOfExpansion' ? (
                                            <CustomMultiSelectInline
                                                value={
                                                    Array.isArray(row[col.key])
                                                        ? row[col.key]
                                                        : row[col.key]
                                                          ? [row[col.key]]
                                                          : []
                                                }
                                                handleOnChange={(
                                                    selectedValues: string[]
                                                ) => {
                                                    handleChange(
                                                        rowIndex,
                                                        col.key,
                                                        selectedValues
                                                    );
                                                }}
                                                options={(
                                                    businessPurpose || []
                                                ).map((opt: ListTypeEntry) => ({
                                                    key: String(opt.key),
                                                    name: opt.name
                                                }))}
                                                name={`purpose-${rowIndex}`}
                                                placeholder="Select Purpose"
                                                disabled={false}
                                            />
                                        ) : col.type === 'select' &&
                                          col.key === 'targetMarket' ? (
                                            <select
                                                className="custom-select"
                                                value={row[col.key] || ''}
                                                onChange={(e) =>
                                                    handleChange(
                                                        rowIndex,
                                                        col.key,
                                                        e.target.value
                                                    )
                                                }
                                            >
                                                <option
                                                    value=""
                                                    disabled
                                                    hidden
                                                >
                                                    Select
                                                </option>
                                                {options
                                                    ?.filter((opt: any) => {
                                                        const otherSelectedValues =
                                                            initialData
                                                                .filter(
                                                                    (
                                                                        _,
                                                                        index
                                                                    ) =>
                                                                        index !==
                                                                        rowIndex
                                                                )
                                                                .map(
                                                                    (r) =>
                                                                        r[
                                                                            col
                                                                                .key
                                                                        ]
                                                                )
                                                                .filter(
                                                                    Boolean
                                                                );

                                                        return !otherSelectedValues.includes(
                                                            opt.key
                                                        );
                                                    })
                                                    .map((opt: any) => (
                                                        <option
                                                            key={opt.key}
                                                            value={opt.key}
                                                        >
                                                            {opt.name}
                                                        </option>
                                                    ))}
                                            </select>
                                        ) : col.type === 'select' &&
                                          col.key === 'previousExperience' ? (
                                            <select
                                                className="custom-select"
                                                value={row[col.key] || ''}
                                                onChange={(e) =>
                                                    handleChange(
                                                        rowIndex,
                                                        col.key,
                                                        e.target.value
                                                    )
                                                }
                                            >
                                                <option
                                                    value=""
                                                    disabled
                                                    hidden
                                                >
                                                    Select
                                                </option>
                                                {defaultValueForSelect?.map(
                                                    (opt: any) => (
                                                        <option
                                                            key={opt.key}
                                                            value={opt.key}
                                                        >
                                                            {opt.name}
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        ) : col.type === 'select' &&
                                          col.key === 'marketPriority' ? (
                                            <select
                                                className="custom-select"
                                                value={row[col.key] || ''}
                                                onChange={(e) =>
                                                    handleChange(
                                                        rowIndex,
                                                        col.key,
                                                        e.target.value
                                                    )
                                                }
                                            >
                                                <option
                                                    value=""
                                                    disabled
                                                    hidden
                                                >
                                                    Select
                                                </option>
                                                {marketPriority
                                                    ?.filter((opt: any) => {
                                                        const count =
                                                            initialData.filter(
                                                                (r) =>
                                                                    r[
                                                                        col.key
                                                                    ] ===
                                                                    opt.key
                                                            ).length;
                                                        if (
                                                            row[col.key] ===
                                                            opt.key
                                                        )
                                                            return true;
                                                        return count < 3;
                                                    })
                                                    .map((opt: any) => (
                                                        <option
                                                            key={opt.key}
                                                            value={opt.key}
                                                        >
                                                            {opt.name}
                                                        </option>
                                                    ))}
                                            </select>
                                        ) : (
                                            <input
                                                type="text"
                                                value={row[col.key] || ''}
                                                onChange={(e) =>
                                                    handleChange(
                                                        rowIndex,
                                                        col.key,
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        )}
                                    </td>
                                ))}

                                {!readOnly && (
                                    <td className="py-1 d-flex justify-content-center align-items-center">
                                        {initialData?.length >= 2 && (
                                            <button
                                                className="delete-btn"
                                                onClick={() =>
                                                    handleDeleteRow(rowIndex)
                                                }
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="14"
                                                    height="16"
                                                    fill="none"
                                                >
                                                    <path
                                                        fill="#d7282f"
                                                        d="M2.615 15.77q-.666 0-1.14-.475A1.55 1.55 0 0 1 1 14.155V1.77H.5a.49.49 0 0 1-.5-.501q0-.212.144-.356A.49.49 0 0 1 .5.77H4a.74.74 0 0 1 .23-.54.74.74 0 0 1 .54-.23h4.46a.74.74 0 0 1 .54.23.74.74 0 0 1 .23.54h3.5q.213 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356a.48.48 0 0 1-.356.143H13v12.385q0 .666-.475 1.14a1.55 1.55 0 0 1-1.14.475zM12 1.77H2v12.385q0 .27.173.442a.6.6 0 0 0 .442.173h8.77q.27 0 .442-.173a.6.6 0 0 0 .173-.442zm-6.692 11q.213 0 .356-.144a.5.5 0 0 0 .144-.356v-8a.49.49 0 0 0-.501-.5.487.487 0 0 0-.499.5v8q0 .212.144.356a.5.5 0 0 0 .356.144m3.385 0q.213 0 .356-.144a.49.49 0 0 0 .143-.356v-8a.489.489 0 0 0-.5-.5.48.48 0 0 0-.356.144.49.49 0 0 0-.144.356v8q0 .212.144.356a.5.5 0 0 0 .357.144"
                                                    />
                                                </svg>
                                            </button>
                                        )}
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* Errors */}
                {errors.length > 0 && (
                    <div className="table-errors mt-2">
                        {errors.map((error, index) => (
                            <div key={index} className="text-danger">
                                {error}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {!readOnly && initialData?.length < 6 && (
                <div className="add-more-wrapper">
                    <Button
                        type="button"
                        onClick={handleAddRow}
                        className="bottom-cut"
                        style={primaryButtonStyle}
                        disabled={disableAdd}
                    >
                        <span className="bottom-cut-span"></span>
                        Add More
                    </Button>
                </div>
            )}
        </>
    );
};

export default DynamicTable;
